var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { cloneElement } from 'react';
import { useId } from '../hooks';
import { wrapperStyle } from './styles';
import RequiredIndicator from './required-indicator';
import Label from './label';
import Error from './error';
import Description from './description';
function FormField(_a) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? 'medium' : _b, description = _a.description, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.requiredIndicator, requiredIndicator = _d === void 0 ? 'showOptional' : _d, _e = _a.inverted, inverted = _e === void 0 ? false : _e, error = _a.error, children = _a.children;
    var id = useId();
    var fieldId = "form-field-".concat(id);
    var errorId = "form-field-error-".concat(id);
    var element = cloneElement(children, __assign(__assign(__assign(__assign({ id: fieldId }, (required && { required: required })), (inverted && { inverted: inverted })), (error && {
        error: true,
        'aria-errormessage': errorId,
        'aria-describedby': errorId,
    })), { size: size }));
    return (_jsxs("div", __assign({ css: wrapperStyle() }, { children: [_jsxs(Label, __assign({ htmlFor: fieldId, inverted: inverted, size: size }, { children: [label, _jsx(RequiredIndicator, { isRequired: required, indicator: requiredIndicator, inverted: inverted, size: size })] })), description && (_jsx(Description, __assign({ inverted: inverted, size: size }, { children: description }))), element, error && (_jsx(Error, __assign({ id: errorId, inverted: inverted, size: size }, { children: error })))] })));
}
export default FormField;
